/**
 * 草图参数方程系统统一数值容差。
 *
 * 所有值使用核心单位：长度为米、角度为弧度、方向残差为无量纲。公式、数值微分、
 * 收敛判定和运行时写回必须从此处读取，禁止在各编译器散落魔法数字。
 */
export const SKETCH_PARAMETRIC_TOLERANCE = {
    /** LM 最大容差满足比；1 表示每行残差必须进入其量纲容差。 */
    residual: 1,
    /** 候选关系最大冗余满足比；1 表示每行残差必须进入其量纲冗余容差。 */
    redundancy: 1,
    /** 各量纲求解收敛容差。 */
    residualByUnit: {
        /** 长度残差容差（米）。 */
        length: 1e-9,
        /** 角度残差容差（弧度）。 */
        angle: 1e-9,
        /** 单位方向点积/叉积残差容差。 */
        direction: 1e-9,
        /** 其他无量纲残差容差。 */
        dimensionless: 1e-9,
    },
    /** 各量纲候选冗余判定容差。 */
    redundancyByUnit: {
        /** 长度冗余容差（米）。 */
        length: 1e-6,
        /** 角度冗余容差（弧度）。 */
        angle: 1e-6,
        /** 单位方向冗余容差。 */
        direction: 1e-6,
        /** 其他无量纲冗余容差。 */
        dimensionless: 1e-6,
    },
    /** 优化尺度使用的最小草图特征长度（米），避免微小/空草图除零。 */
    minimumNormalizationLength: 1e-3,
    /** 零长度、零半径和退化方向判定阈值。 */
    degenerateLength: 1e-12,
    /** 中心差分的基础参数步长。 */
    jacobianStep: 1e-6,
    /** 样条一阶导数相对定义域步长。 */
    splineDerivativeRelativeStep: 1e-6,
    /** 样条一阶导数最小定义域步长。 */
    splineDerivativeMinimumStep: 1e-8,
    /** LM 阻尼下降时允许的最小值。 */
    minimumDamping: 1e-12,
    /** 硬约束 Jacobian 零空间消元的主元容差。 */
    nullSpacePivot: 1e-10,
    /** 分层偏好优化最大迭代次数。 */
    preferenceMaxIterations: 50,
    /** 可达偏好严格候选求解最大迭代次数；超出后回退最近可行位置。 */
    preferenceFeasibilityMaxIterations: 32,
    /** 分层偏好参数步长停止阈值。 */
    preferenceStep: 1e-10,
} as const;
